import { oc } from "@orpc/contract";
import { z } from "zod";

// ─── Schemas ────────────────────────────────────────────────────────────────

export const ProductVariantSearchResultSchema = z.object({
  productVariantId: z.string().uuid(),
  productId: z.string(),
  variantSku: z.string().nullable(),
  productName: z.string(),
  productDescription: z.string().nullable(),
  uom: z.string().nullable(),
  active: z.boolean(),
});

export const SearchProductVariantsInputSchema = z.object({
  query: z.string().trim().min(1),
  isSellable: z.coerce.boolean().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});

export const SearchProductVariantsResponseSchema = z.object({
  results: z.array(ProductVariantSearchResultSchema),
});

// ─── Contract ───────────────────────────────────────────────────────────────

export const productVariantsContracts = {
  search: oc
    .input(SearchProductVariantsInputSchema)
    .output(SearchProductVariantsResponseSchema)
    .route({
      method: "GET",
    }),
} as const;

// ─── Type exports ───────────────────────────────────────────────────────────

export type ProductVariantSearchResult = z.infer<
  typeof ProductVariantSearchResultSchema
>;
export type SearchProductVariantsInput = z.infer<
  typeof SearchProductVariantsInputSchema
>;
export type SearchProductVariantsResponse = z.infer<
  typeof SearchProductVariantsResponseSchema
>;
